import { RouterModule, Routes } from '@angular/router';

import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { NewPostComponent } from './new-post/new-post.component';
import { MypublicationsComponent } from './mypublications/mypublications.component';
import { EditpublicationComponent } from './editpublication/editpublication.component';
import { PrivacidadComponent } from './privacidad/privacidad.component';
import { DetailsPublicationComponent } from './details-publication/details-publication.component';
import {  DetailsmypublicationComponent } from "./detailsmypublication/detailsmypublication.component";
import { AboutComponent } from './about/about.component';

const APP_ROUTES: Routes = [
  { path: 'home', component: HomeComponent },
  { path: 'login', component: LoginComponent },
  { path: 'newPost', component: NewPostComponent },
  { path: 'mypublications', component: MypublicationsComponent },
  { path: 'editpublication', component: EditpublicationComponent },
  { path: 'privacidad', component: PrivacidadComponent },
  { path: 'detailsPublication', component: DetailsPublicationComponent },
  { path: 'about', component: AboutComponent },
  {path: 'detailsmyPublication', component: DetailsmypublicationComponent},
  { path: '**', pathMatch: 'full', redirectTo: 'login' }
];

export const APP_ROUTING = RouterModule.forRoot(APP_ROUTES,{useHash: true});



// WEBPACK FOOTER //
// C:/Users/CLAUDIA/Desktop/Timeplacebook2/src/app/app.routes.ts